/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Container, Grid } from 'theme-ui';
import SectionHeader from 'components/section-header';
import TeamCard from 'components/team-card';
import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';

import Rizwan from 'assets/team/rizwan.webp';
import Muhammed from 'assets/team/mohammed.webp';
import Farshan from 'assets/team/farshan.webp';
import Hisham from 'assets/team/hisham.webp';


const data = [
  {
    id: 1,
    imgSrc: Rizwan,
    altText: 'Rizwan Vadakkan',
    title: 'Rizwan Vadakkan',
    designation: 'Co-Founder',
    socialProfile: [
      {
        id: 1,
        name: 'facebook',
        path: 'https://instagram.com/rizwanvadakkan',
        icon: <FaFacebookF />,
      },
      {
        id: 2,
        name: 'linkedin',
        path: 'https://www.linkedin.com/in/rvadakkan/',
        icon: <FaLinkedin/>,
      },
      {
        id: 3,
        name: 'instagram',
        path: 'https://instagram.com/rizwanvadakkan',
        icon: <FaInstagram />,
      },
    ],
  },
  {
    id: 2,
    imgSrc: Muhammed,
    altText: 'Muhammed CH',
    title: 'Muhammed CH',
    designation: 'Co-Founder',
    socialProfile: [
      {
        id: 1,
        name: 'facebook',
        path: 'https://instagram.com/_muhammedch',
        icon: <FaFacebookF />,
      },
      {
        id: 2,
        name: 'linkedin',
        path: '#',
        icon: <FaLinkedin />,
      },
      {
        id: 3,
        name: 'instagram',
        path: 'https://instagram.com/_muhammedch',
        icon: <FaInstagram />,
      },
    ],
  },
  {
    id: 3,
    imgSrc: Farshan,
    altText: 'Muhammed Farshan',
    title: 'Muhammed Farshan',
    designation: 'Co - Founder',
    socialProfile: [
      {
        id: 1,
        name: 'facebook',
        path: 'https://instagram.com/farshan_____',
        icon: <FaFacebookF />,
      },
      {
        id: 2,
        name: 'linkedin',
        path: '#',
        icon: <FaLinkedin />,
      },
      {
        id: 3,
        name: 'instagram',
        path: 'https://instagram.com/farshan_____',
        icon: <FaInstagram />,
      },
    ],
  },

  {
    id: 4,
    imgSrc: Hisham,
    altText: 'Hisham Kallingal',
    title: 'Hisham Kallingal',
    designation: 'Co - Founder',
    socialProfile: [
      {
        id: 1,
        name: 'facebook',
        path: 'https://instagram.com/hkallingal',
        icon: <FaFacebookF />,
      },
      {
        id: 2,
        name: 'linkedin',
        path: '#',
        icon: <FaLinkedin />,
      },
      {
        id: 3,
        name: 'instagram',
        path: 'https://instagram.com/hkallingal',
        icon: <FaInstagram />,
      },
    ],
  },
  
];

export default function TeamSection() {
  return (
    <section>
      <Container>
        <SectionHeader
          slogan="our team"
          title="United by vision, driven by passion"
        />

        <Grid sx={styles.grid}>
          {data.map((item) => (
            <TeamCard
              key={`team--key${item.id}`}
              src={item.imgSrc}
              altText={item.altText}
              title={item.title}
              designation={item.designation}
              social={item.socialProfile}
            />
          ))}
        </Grid>
      </Container>
    </section>
  );
}

const styles = {
  grid: {
    mt: [0, null, -6, null, -4],
    gridGap: ['35px 0px', null, 0, null, null, '30px 35px'],
    gridTemplateColumns: [
      'repeat(2,1fr)',
      null,
      'repeat(2,1fr)',
      null,
      'repeat(3,1fr)',
    ],
  },
};
